import React from 'react';
import { style } from 'typestyle';
import ArrowBackIcon from 'mdi-react/ChevronLeftIcon';
import * as styles from './back-button.styles';
import { Center, CenterDirection } from '../center/center.component';

interface Props {
  readonly title: string;
  readonly navigate: () => void;
}

const BackButton = ({ title, navigate }: Props): React.JSX.Element => (
  <div className={style(styles.backButton)} onClick={navigate} role="presentation">
    <Center direction={CenterDirection.Vertical}>
      <ArrowBackIcon className={style(styles.backArrow)} />
      {title}
    </Center>
  </div>
);

export default BackButton;
